var _script, _g, _defs, _script2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052ff",
    d: "M63.888 128C99.296 128 128 99.346 128 64S99.296 0 63.888 0C30.295 0 2.737 25.792 0 58.62h84.741V69.38H0C2.737 102.208 30.295 128 63.888 128z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h128v128H0z",
    fill: "#fff"
  })))), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.ce91548c45c4f17f372fa01f5fdf5ae3.svg";
export { ForwardRef as ReactComponent };